import IMG_KPI_CALCULATED_TOOLTIP_GB from 'assets/images/kpi/kpi-tooltip-content.png';
import IMG_KPI_CALCULATED_TOOLTIP_US from 'assets/images/kpi/kpi-tooltip-content-us.png';

export const KPI_CALCULATED_TOOLTIP_IMAGES = {
  US: IMG_KPI_CALCULATED_TOOLTIP_US,
  GB: IMG_KPI_CALCULATED_TOOLTIP_GB,
};
